export const styles = {
  footer: {
    background: 'linear-gradient(0deg, #100B16, #100B16),linear-gradient(0deg, #322146, #322146)'
  }
};